import React from 'react'
import styled from 'styled-components'
import {ProgressBar} from 'react-bootstrap'
import BookResponse from '../routes/book/BookResponse'

interface Props {
    book: BookResponse
    isShowPage?: boolean
    isOneLine?: boolean
}

const BookPageBar: React.FC<Props> = ({book, isShowPage = true, isOneLine = true}) => {
    return (
        <Container>
            <div className={!isShowPage ? 'col-12' : isOneLine ? 'col-8 col-xl-6 col-xxl-8 ps-4' : 'col-12 col-xl-6 col-xxl-7'}>
                <ProgressBar variant="book" className="mt-3 mb-3 w-100" now={calculateProgress(book)}
                             label={`${Math.round(calculateProgress(book))}%`}/>
            </div>

            {isShowPage && (
                <div className={`${isOneLine ? 'col-4 col-xl-6 col-xxl-4' : 'col-12 col-xl-6 col-xxl-5 p-0'} text-end`}>
					<span className="force-1-line text p-0">
						<b className="text-book">{`${book.currentPage == null || book.currentPage < 0 ? 0 : book.currentPage}`}</b> / {`${book.endPage}`}
					</span>
                </div>
            )}
        </Container>
    )
}

const calculateProgress = (book: BookResponse) => {
    if (book.endPage === 0) {
        return book.status === 'DONE' ? 100 : 0
    }
    const currentPage = book.currentPage == null ? 0 : book.currentPage
    return (currentPage / book.endPage) * 100
}

const Container = styled.div.attrs({
    className: 'row'
})`
    align-items: center;
    text-align: center;
    justify-content: end;
`

export default BookPageBar
